import { Sprite } from '@pixi/sprite';

Sprite.prototype._tintedCanvas = null;
Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
  renderer.plugins.sprite.render(this);
};
//# sourceMappingURL=Sprite.mjs.map
